import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Grid,
  Box,
  Stack,
} from "@mui/material";

const ViewMonitoringDetails = ({ open, onClose, details }) => {
  if (!details) return null;

  const additionalNames = JSON.parse(details.add_name || "{}");

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Monitoring Details</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Stack direction="row" spacing={2}>
            <Stack flex={1}>
              <Typography variant="subtitle1">Name:</Typography>
              <Typography variant="body1">{details.name}</Typography>
            </Stack>
            <Stack flex={1}>
              <Typography variant="subtitle1">Phone:</Typography>
              <Typography variant="body1">{details.phone}</Typography>
            </Stack>
          </Stack>
          <Stack direction="row" spacing={2}>
            <Stack flex={1}>
              <Typography variant="subtitle1">Email:</Typography>
              <Typography variant="body1">{details.email}</Typography>
            </Stack>
            <Stack flex={1}>
              <Typography variant="subtitle1">Address:</Typography>
              <Typography variant="body1">
                {details.street}, {details.city}, {details.state} {details.zip}
              </Typography>
            </Stack>
          </Stack>
          <Stack>
            <Typography variant="subtitle1">Additional Names:</Typography>
            <Box ml={2}>
              {Object.entries(additionalNames).map(([key, value]) => (
                <Typography key={key} variant="body1">
                  {key}: {value}
                </Typography>
              ))}
            </Box>
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewMonitoringDetails;
